var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_63729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5001 10C32.1616 10 36.0115 14.0983 36.0115 14.0983C36.0115 14.0983 36.451 17.1266 36.1739 23.2405C35.7536 32.4688 24.5096 38 24.5096 38.0096C24.5096 38.0191 13.2561 32.4592 12.8358 23.2405C12.5492 17.1266 12.9887 14.0983 12.9887 14.0983C12.9887 14.0983 16.8385 10 24.5001 10Z",
    fill: "#ED2E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7492 22.1229C18.7492 18.8653 21.3285 16.2095 24.5001 16.2095C27.6717 16.2095 30.2511 18.7888 30.2511 21.9605C30.2511 24.492 28.073 26.5746 26.4012 27.6445C27.0508 28.0171 28.4837 28.4088 29.8594 28.533C31.8942 26.9567 33.0883 24.5302 33.0883 21.9605C33.1074 17.2126 29.2671 13.3532 24.5192 13.3341C19.7714 13.3149 15.9119 17.1553 15.8928 21.9031C15.8928 21.9223 15.8928 21.9414 15.8928 21.9605C15.8928 24.8264 17.087 27.3675 19.3415 29.3163C21.4527 31.1409 24.5288 32.3542 28.0443 32.9274C28.8086 32.507 30.1078 31.2651 30.595 30.5391C27.6622 30.1665 24.8918 29.4501 23.029 28.4756C20.1917 26.9854 18.7492 24.8455 18.7492 22.1229Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_63729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5196,
    height: 28,
    fill: "white",
    transform: "translate(12.7402 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualys);
export default __webpack_public_path__ + "static/media/Qualys.12b42cfd202a21d408b7c19cd05a2b45.svg";
export { ForwardRef as ReactComponent };